<template lang="pug">
  header
    transition(name='logo', mode='out-in', appear)
      .logo(@click='toggleNav', @mouseenter='toggleNavHover', @mouseleave='toggleNavHover', :class='{hover:revealHeader}')
        .logo-ctn(v-html='logo')
        span Menu
    .indicator
      router-link(to='/', :class='{hover:revealHeader}', @mouseenter.native='headerMouseover', @mouseleave.native='headerMouseover')
        transition(v-if='indicator !== null', name='indicator', @enter='indicatorEnter', :css='false', mode='out-in', appear)
          .icon-wrap(:key='indicator')
        .icon(v-html='icon')
        span.home-link Home
    transition(name='coordinates', @before-enter='coordinatesBeforeEnter', @enter='coordinatesEnter', :css='false', mode='out-in', appear)
      .coordinates
        router-link(to='/kontakt', :class='{hover:revealHeader}', @mouseenter.native='headerMouseover', @mouseleave.native='headerMouseover')
          span
            |48°&nbsp;12'&nbsp;30&nbsp;N
            br
            |16°&nbsp;22'&nbsp;19&nbsp;
            span E
          span.contact-link Kontakt
        router-link(to='/kontakt', v-html='contact').icon
    .clear
</template>

<script>
  import {TweenLite, Power3} from 'gsap'
  require('script-loader!@/assets/js/MorphSVGPlugin')

  export default {
    props: ['indicator'],
    data () {
      return {
        logo: require('@/assets/img/donauhof-logo.svg'),
        contact: require('@/assets/img/donauhof-contact.svg'),
        revealHeader: false,
        icon: require('@/assets/img/donauhof-home.svg'),
        mobileNavOpen: false,
        svg: {
          path: null,
          light_wave: 'M800,66c0,0-58-5-162-5c-164,0-227,9-403,9C102,70,0,66,0,66V0.2h800V66z',
          wave: 'M800,60c0,0-58-11-162-11c-164,0-227,21-403,21C102,70,0,60,0,60V0.2h800V60z',
          rect: 'M800,70c0,0-58-0.5-162-0.5c-164,0-227,0-403,0C102,69.5,0,70,0,70V0h800V70z'
        }
      }
    },
    computed: {
      indicatorPath () {
        // let ctn = document.createElement('object')
        // ctn.insertAdjacentHTML('afterbegin', this.indicator)
        // return ctn.querySelector('svg path').getAttribute('d')
        // throws prerender spa error
        let el = new DOMParser().parseFromString(this.indicator, 'image/svg+xml').querySelector('path').getAttribute('d')
        return el
        // return document.createRange().createContextualFragment(this.indicator).querySelector('path').getAttribute('d')
      }
    },
    methods: {
      coordinatesBeforeEnter (el) {
        TweenLite.set(el, {scale: 0, autoAlpha: 0})
      },
      coordinatesEnter (el, done) {
        TweenLite.to(el, 1, {
          scale: 1,
          autoAlpha: 1,
          ease: Power3.easeOut,
          onComplete: function () {
            el.style.transform = ''
            el.style.zIndex = ''
            el.style.opacity = ''
            done()
          }
        })
      },
      indicatorEnter (el, done) {
        let icon = document.querySelector('.indicator .icon')
        icon.style.transition = 'transform 2s cubic-bezier(0.77, 0, 0.175, 1)'
        icon.style.transform = 'scale3d(1,1,1)'
        TweenLite.to('.indicator svg path', 2, {
          // morphSVG: {shape: this.indicatorPath, shapeIndex: 5},
          morphSVG: this.indicatorPath,
          ease: Power3.easeInOut,
          onComplete: function () {
            icon.style.transition = ''
            done()
          }
        })
      },
      navAnim (svg, d) {
        // anime({
        //   targets: '.shape svg path',
        //   d: svg,
        //   duration: d,
        //   easing: 'easeInOutQuart'
        // })
        // TweenLite.to('.shape svg path', 1, {scale: 2})
        // TweenLite.to('.shape svg path', 1, {morphSVG: svg, ease: Power3.easeInOut})
        TweenLite.to('.shape svg path', d / 1000, {morphSVG: svg, ease: Power3.easeInOut})
      },
      toggleNav (ev) {
        let body = document.body.classList
        // closing now
        if (body.contains('has-nav-open')) {
          // wave
          this.navAnim(this.svg.wave, 1000)
          body.toggle('is-closed')
        // opening now
        } else {
          // straight
          this.navAnim(this.svg.rect, 1000)
          body.remove('is-closed')
        }
        body.toggle('has-nav-open')
        if (this.$parent.isMobile()) {
          let navHeight = document.querySelector('nav').clientHeight
          this.mobileNavOpen = !this.mobileNavOpen
          document.querySelector('.wrap > *:not(header)').style.transform = this.mobileNavOpen ? 'translate3d(0,' + navHeight + 'px, 0)' : 'translate3d(0,0,0)'
        }
      },
      toggleNavHover (ev) {
        let body = document.body.classList
        if (!this.$parent.isMobile()) {
          this.revealHeader = !this.revealHeader
          body.toggle('has-nav-hover')
          body.remove('is-closed')
          if (body.contains('has-nav-open')) {
            if (ev.type === 'mouseenter') {
              this.hover = true
              setTimeout(() => {
                if (this.hover) this.navAnim(this.svg.light_wave, 500)
              }, 250)
            } else {
              this.hover = false
              setTimeout(() => {
                if (!this.hover) this.navAnim(this.svg.rect, 500)
              }, 250)
            }
          }
        }
      },
      headerMouseover () {
        if (!this.$parent.isMobile()) this.revealHeader = !this.revealHeader
      }
    }
  }
</script>

<style lang="scss">
  @import "~utils";
  header {
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: $gutter/2 $gutter;
    z-index: 10;
    @include desktop {
      position: relative;
      padding: $gutter*4 0;
      background: transparent;
      z-index: inherit;
    }
    .home-link, .contact-link, .logo span {
      @include sans;
      font-size: 0.75rem;
      letter-spacing: 0.4em;
      text-transform: uppercase;
      font-weight: bold;
    }
    .logo {
      width: 2.25rem;
      height: 2.25rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      text-align: center;
      cursor: pointer;
      transition: all .75s $easeInOut;
      transition-delay: .0625s;
      z-index: 10;
      // padding-top: 1rem;
      svg {
        max-height: 2.25rem;
        @include desktop {
          max-height: 4.6875rem;
        }
        circle, path {
          transition: all .5s $easeInOut;
        }
      }
      @include desktop {
        width: 4.6875rem;
        height: 8.6875rem;  
        padding: 2rem 0;
        // svg path {
        //   fill: $black;
        // }
      }
      span {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        line-height: 8.6875rem;
        text-indent: .4em;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        transform: scale3d(.75, .75, 1);
        transition: all .5s $easeInOut;
        // border-radius: 50%;
        // border: 2px solid $black;
        opacity: 0;
      }
      &.hover {
        .logo-ctn svg path {
          opacity: 0;
          transition: all .5s $easeOut;
          transition-delay: .125s;
          transform-origin: center center;
          // transform: scale3d(1,0,1);
          &:first-of-type {
            transform: translate3d(0, 8px, 0);
          }
          // &:nth-of-type(3) {
          //   transform: translate3d(0, -8px, 0);
          // }
          &:nth-of-type(2) {
            transform: translate3d(0, -8px, 0);
          }
          transition: all .5s $easeOut;
        }
        span {
          opacity: 1;
          transform: scale3d(1, 1, 1);
          transition: all .5s $easeInOut;
        }
      }
    }
    .indicator {
      display: inline-block;
      vertical-align: middle;
      width: 50%;
      text-align: left;
      position: relative;
      @include desktop {
        text-align: center;
      }
      a {
        display: inline-block;
      }
      .icon {
        // transition: transform 2s $easeInOut;
        transform: scale3d(0,0,1);
        transition: transform .375s $easeInOut;
        // transition-delay: .125s;
        svg {
          width: 2.25rem;
          height: 2.25rem;
          path {
            stroke-width: 1.5;
            transition: stroke .375s $easeInOut;
            // transition-delay: .125s;
          }
        }
      }
      .home-link {
        position: absolute;
        height: 2rem;
        line-height: 2rem;
        top: 50%;
        left: 50%;
        text-indent: .25em;
        display: inline-block;
        transform: translate3d(-50%, -50%, 0) scale3d(.9, .9, 1);
        opacity: 0;
        transition: all .375s $easeInOut;
        transition-delay: 0s;
      }
      a.hover {
        .icon {
          transform: scale3d(1.25, 1.25, 1) !important;
          transition: transform .75s $easeOut;
          transition-delay: .125s;
          svg path {
            stroke: #ffffff !important;
            transition: stroke .75s $easeOut;
            transition-delay: .125s;
          }
        }
        .home-link {
          opacity: 1;
          transition: all .75s $easeOut;
          transition-delay: .125s;
          transform: translate3d(-50%, -50%, 0) scale3d(1, 1, 1);
        }
      }
    }
    .coordinates {
      display: inline-block;
      vertical-align: middle;
      width: 50%;
      text-align: right;
      position: relative;
      @include desktop {
        text-align: center;
      }
      a {
        &:not(.icon) {
          display: none;
          @include desktop {
            display: inline-block;
          }
        }
        span:not(.contact-link) {
          display: none;
          transition: all .375s $easeInOut;
          @include desktop {
            display: inline-block;
            text-align: justify;
            word-spacing: 1rem;
            line-height: 1.5555556;
            font-weight: bold;
            color: $gold;
            // transition: all .5s $easeIn;
            // transition-delay: .25s;
            @include sans;
            font-size: 1.125rem;
            font-feature-settings: 'tnum';
            span {
              position: relative;
              left: .125rem;
              // transition: all .5s $easeIn;
              // transition-delay: .25s;
            }
          }
        }
      }
      .contact-link {
        position: absolute;
        top: 50%;
        left: 50%;
        text-indent: .25em;
        display: inline-block;
        transform: translate3d(-50%, -50%, 0) scale3d(.9, .9, 1);
        opacity: 0;
        transition: all .375s $easeInOut;
        transition-delay: 0s;
      }
      .icon {
        display: inline-block;
        @include desktop {
          display: none;
        }
        svg {
          width: 2.25rem;
          height: 2.25rem;
        }
      }
      a.hover {
        & > span:not(.contact-link), & > span span {
          transform: scale3d(1.25, 1.25, 1);
          transition: all .75s $easeOut;
          transition-delay: .125s;
          color: $light-blue;
        }
        .contact-link {
          opacity: 1;
          transition: all .75s $easeOut;
          transition-delay: .125s;
          transform: translate3d(-50%, -50%, 0) scale3d(1, 1, 1);
        }
      }
    }
  }

  .has-nav-hover {
    .wrap > *:not(header), .indicator, .coordinates, .background-ctn {
      transform: translate3d(0, $navHeight/5, 0);
      transition: all .75s $easeInOut;
      transition-delay: .0625s;
    }
    nav {
      // transform: scale3d(1, .2, 1);
      transform: translate3d(0, -30%, 0) scale3d(1, .5, 1);
      transition: all .75s $easeInOut;
    }
  }

  .is-closed.has-nav-hover {
    .wrap > *:not(header), .indicator, .coordinates, .background-ctn {
      transform: translate3d(0, 0, 0);
      transition: all .75s $easeInOut;
      transition-delay: .0625s;
    }
    nav {
      transform: translate3d(0, -100%, 0);
      transition: all .75s $easeInOut;
    }
  }

  .has-nav-open {
    .wrap > *:not(header), .indicator, .coordinates, .background-ctn {
      @include desktop {
        transform: translate3d(0, $navHeight, 0);
        transition: all .75s $easeInOut;
        transition-delay: .0625s;
      }
    }
    .logo {
      @include desktop {
        transform: translate3d(-50%, $navHeight * -0.775, 0);
        transition: all .75s $easeInOut;
        transition-delay: .0625s;
      }
      svg {
        circle, path {
          transition: all .25s $easeInOut;
        }
      }
      span {
        transition: all .25s $easeInOut;
      }
      @include desktop {
        &:hover {
          svg circle, svg path {
            stroke: $gold !important;
            transition: all .5s $easeOut;
          }
          span {
            color: $gold; 
            transition: all .5s $easeOut;
          }
        }
      }
    }
    nav {
      transform: scale3d(1, 1, 1);
      @include desktop {
        transform: translate3d(0,0,0) scale3d(1, 1, 1);
      }
      transition: all .75s $easeInOut;
      li {
        transform: translate3d(0, 0, 0);
        opacity: 1;
        transition: all .5s $easeOut;
        @include stagger(6, .375s, .0625s);
        @include desktop {
          @include stagger(4, .375s, .0625s);
        }
      }
    }
  }
// logo transition
.logo-enter, .logo-leave-to {
  opacity: 0;
  transform: translate3d(-50%, -60%, 0) !important;
}

.logo-enter-to, .logo-leave {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.logo-enter-active, .logo-leave-active {
  transition: all 1s $easeOut;
}

// indicator, coordinates transition
.indicator-enter, .indicator-leave-to {
  opacity: 0;
  transform: scale3d(0, 0, 1);
}

.indicator-enter-to, .indicator-leave {
  opacity: 1;
  transform: scale3d(1, 1, 1)
}

.indicator-enter-active, .indicator-leave-active {
  transition: all 1s $easeOut;
}

// indicator, coordinates transition
.coordinates-enter, .coordinates-leave-to  {
  opacity: 0;
  transform: scale3d(0, 0, 1);
}

.coordinates-enter-to, .coordinates-leave {
  opacity: 1;
  transform: scale3d(1, 1, 1);
}

.coordinates-enter-active, .coordinates-leave-active {
  transition: all 1s $easeOut;
}


</style>



// WEBPACK FOOTER //
// Header.vue?4bc7789e